// extracted by mini-css-extract-plugin
module.exports = {"subHeaderContainer":"_2VhIpDY","error":"_39s4rC7"};